module.exports = __webpack_public_path__ + "static/image 13-8f7ca6a21058a4bca50dd7345d0bfc75.png";